import React, { useEffect }   from 'react';
import {
  useDispatch,
  useSelector
}                             from "react-redux";
import service                from "../../../services";
import { IBookmarks }         from "../../../services/cayuga/types";
import { ApplicationState }   from "../../../store";
import { APIState }           from "../../../store/API/types";
import { setSelectedItems }   from "../../../store/bookmarks/actions";
import { BookmarkState }      from "../../../store/bookmarks/types";
import { BrowseState }        from "../../../store/browse/types";
import { LayoutState }        from "../../../store/layouts/types";
import {
  resetTimestrips,
  setTimelineDate
}                             from "../../../store/timeline/actions";
import { doCayugaBrowseGoTo } from "../../../utils";
import { triggerSingleCheck } from "../BookmarkComponent/BookmarkComponent";
import BookmarkInfoComponent  from "../BookmarkInfoComponent";


interface Props {
  onChangeTime: (time: any) => void,
}


const BkmFormDeleteComponent: React.FC<Props> = ({onChangeTime}) => {
  const dispatch = useDispatch();
  const {token} = useSelector<ApplicationState, APIState>(state => state.API)
  const {browsePanes} = useSelector<ApplicationState, BrowseState>(state => state.browse);
  const {checkedPane} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const {selected} = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);
  const cameraBookmarks: Array<IBookmarks> = typeof checkedPane === 'number' ? browsePanes?.[checkedPane]?.bookmarks : [];

  const selectedBookmark = cameraBookmarks && cameraBookmarks.filter(bkm => bkm["a:BookmarkID"] === selected[0])[0];
  const selectedId = selectedBookmark && selectedBookmark["a:BookmarkID"];

  const doSelect = (e: React.MouseEvent, id: string) => {
    const {selectedItems} = triggerSingleCheck(selected, id);

    dispatch(setSelectedItems(selectedItems));
  };

  useEffect(() => {
    if (selectedBookmark && typeof checkedPane === 'number') {
      onChangeTime(parseInt(selectedBookmark["a:Timestamp"]));
      dispatch(setTimelineDate(parseInt(selectedBookmark["a:Timestamp"])));
      dispatch(resetTimestrips(parseInt(selectedBookmark["a:Timestamp"])));

      doCayugaBrowseGoTo(token, parseInt(selectedBookmark["a:Timestamp"]), checkedPane, 1, browsePanes[checkedPane].id, service);
    }
  }, [selectedId]);

  return (
    <div className='bkm-form delete-form'>
      <div className="bookmarks scroll">
        {
          cameraBookmarks && cameraBookmarks.map(bkm =>
            <BookmarkInfoComponent key={bkm["a:BookmarkID"]}
                                   id={bkm["a:BookmarkID"]}
                                   onClick={doSelect}
                                   isSelected={typeof checkedPane === 'number' ? selected.includes(bkm['a:BookmarkID']) : false}
                                   name={typeof bkm["a:Name"] === 'string'
                                     ? bkm['a:Name']
                                     : `Bookmark #${bkm["a:BookmarkID"]}`
                                   }
            />
          )
        }
      </div>
    </div>
  );
};

export default BkmFormDeleteComponent;